import { createMachine } from 'xstate';

export const assiseMachine = createMachine({
  id: 'assise',
  initial: 'as-Beckoning',
  states: {
    "as-Beckoning": { on: { "NEXT01": "as-Playing Drums" }},
    "as-Playing Drums": { on: { "NEXT01": "as-Pointing" }},
    "as-Pointing": { on: { "NEXT01": "as-Seated Idle" }},
    "as-Seated Idle": { on: { "NEXT01": "as-Sitting" }},
    "as-Sitting": { on: { "NEXT01": "as-Sitting 2" }},
    "as-Sitting 2": { on: { "NEXT01": "as-Sitting And Pointing" }},
    "as-Sitting And Pointing": { on: { "NEXT01": "as-Sitting Angry" }},
    "as-Sitting Angry": { on: { "NEXT01": "as-Sitting Clap" }},
    "as-Sitting Clap": { on: { "NEXT01": "as-Sitting Clap 3" }},
    "as-Sitting Clap 3": { on: { "NEXT01": "as-Sitting Disapproval" }},
    "as-Sitting Disapproval": { on: { "NEXT01": "as-Sitting Disapproval 2" }},
    "as-Sitting Disapproval 2": { on: { "NEXT01": "as-Sitting Laughing" }},
    "as-Sitting Laughing": { on: { "NEXT01": "as-Sitting Rubbing Arm" }},
    "as-Sitting Rubbing Arm": { on: { "NEXT01": "as-Sitting Talking" }},
    "as-Sitting Talking": { on: { "NEXT01": "as-Sitting Thumbs Up" }},
    "as-Sitting Thumbs Up": { on: { "NEXT01": "as-Sitting Yell" }},
    "as-Sitting Yell": { on: { "NEXT01": "as-Stand To Sit" }},
    "as-Stand To Sit": { on: { "NEXT01": "as-Stand Up" }},
    "as-Stand Up": { on: { "NEXT01": "as-Standing Clap" }},
    "as-Standing Clap": { on: { "NEXT01": "as-Beckoning" }},
  }
});



